import { WixDataApi, } from '@wix/wix-data-items-common';
import { WixDataItemsHttpClient } from './data-items-api-client';
export function createWixData(httpClient, sideEffects, environment) {
    const clientFactory = (interceptor) => {
        return new WixDataItemsHttpClient(httpClient, interceptor, sideEffects);
    };
    const allowGet = true;
    return new WixDataApi(clientFactory, allowGet, environment);
}
//# sourceMappingURL=wix-data-api.js.map